export default __webpack_public_path__ + "static/indian-081a5c963827a3fecc163563063f1a1c.jpg";